"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressService = void 0;
const AddressServiceLive_1 = require("./AddressServiceLive");
const AddressServiceStub_1 = require("./AddressServiceStub");
class AddressService {
    static create(stub) {
        if (stub) {
            return new AddressServiceStub_1.AddressServiceStub();
        }
        return new AddressServiceLive_1.AddressServiceLive();
    }
}
exports.AddressService = AddressService;
//# sourceMappingURL=AddressService.js.map